import React from 'react';

const LinkIcon = ({ fill = 'white', className }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" className={className}>
            <rect
                x="13.3887"
                y="2.36832"
                width="6"
                height="6"
                transform="rotate(45 13.3887 2.36832)"
                stroke={fill}
                strokeWidth="2"
            />
            <rect
                x="6.31738"
                y="9.4396"
                width="6"
                height="6"
                transform="rotate(45 6.31738 9.4396)"
                stroke={fill}
                strokeWidth="2"
            />
            <rect x="12.6816" y="5.9043" width="2" height="10" transform="rotate(45 12.6816 5.9043)" fill={fill} />
        </svg>
    );
};

export default LinkIcon;
